import { computed, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { useInboxOrderSupportRenameFlag } from '@/features/reviews/composables/useInboxOrderSupportRenameFlag'
import { FeatureFlags } from '@/plugins/featureFlags'

export const usePageTitle = (): ComputedRef<string | undefined> => {
  const route = useRoute()
  const { t } = useI18n()
  const renameEnabled = useInboxOrderSupportRenameFlag()

  return computed(() => {
    for (let i = route.matched.length - 1; i > 0; i--) {
      const match = route.matched[i]
      if (match?.meta?.title) {
        const title = match.meta.title
        // Handle staff pay/timesheets route with feature flag
        if (match.name === 'brand.staff.pay') {
          const titleKey = FeatureFlags.isEnabled('hermes.pay')
            ? 'staff-pay'
            : 'staff-timesheets'
          return t(`core.pages.${titleKey}.title`)
        }
        // Feedback → Customer support rename gated on inbox_order_support_rename
        if (match.name === 'brand.feedback' && renameEnabled.value) {
          return t('core.pages.restaurant.customer-support.title')
        }
        return t(`core.pages.${title}.title`)
      }
    }

    return undefined
  })
}
